import { getApolloSessionDetails } from '../../../features/apolloSession/apolloSession.selectors';
import { useAppSelector, useAppDispatch } from '../../useReduxToolkit';
import { useRedirect } from '../../useRedirect';
import { getSlugFromCheckInPathname } from '../../useRedirect/helpers';
import { initialize as initializeApolloSession } from '../../../features/apolloSession/apolloSession.slice';
import { StorageKeys } from '../../../shared/constants';
import { storage } from '@doxyme/ui/utils';

type UseRedirectAfterCallSuccessType = {
  redirectAfterProviderLeft: () => void;
};
export const useRedirectAfterCallSuccess =
  (): UseRedirectAfterCallSuccessType => {
    const apolloSession = useAppSelector(getApolloSessionDetails);
    const { referrer } = apolloSession;
    const dispatch = useAppDispatch();
    const { redirectToWaitingRoom } = useRedirect();

    const redirectAfterProviderLeft = (): void => {
      const roomName = getSlugFromCheckInPathname(referrer);
      if (roomName === undefined) {
        return;
      }

      const updateSessionValues = {
        ...apolloSession,
        isV2: false,
      };
      storage.setItem(StorageKeys.ApolloSession, updateSessionValues);
      dispatch(initializeApolloSession({}));
      redirectToWaitingRoom(roomName);
    };

    return { redirectAfterProviderLeft };
  };
